var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chevron_Right",
    d: "M4.38055 4.17879L0.705192 0.132857C0.54392 -0.0442864 0.282633 -0.0442863 0.120953 0.132857C-0.0403192 0.310001 -0.0403192 0.597727 0.120953 0.774871L3.50478 4.49978L0.121361 8.22468C-0.0399108 8.40182 -0.0399108 8.68955 0.121361 8.86714C0.282633 9.04429 0.544327 9.04429 0.705599 8.86714L4.38095 4.82125C4.53975 4.64594 4.53975 4.35369 4.38055 4.17879Z",
    fill: "#29185E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrRight);
export default __webpack_public_path__ + "static/media/arr-right.4b3a9b67496e8366f3eb922fa337e9e7.svg";
export { ForwardRef as ReactComponent };